import { store } from "../store";
import appConfig from "../appconfig";
import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import ProductsIngredientsProvider from "./ProductsIngredientsProvider";


const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

const IngredientsProvider = Object.freeze({
	getIngredients(skipCounter) {
		const ingredientsQueryParams = {
			tenantId: appConfig.tenantId,
			$skip: skipCounter
		};

		return Promise.all([
			getApi().get("/ingredients", {
				params: ingredientsQueryParams
			})
		]).then(([ ingredientsResponse]) => {
			return {
				ingredientsResponse
			};
		});
	},
	updateIngredient(ingredient, jwtToken) {
		return getApi().put(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, ingredient, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	createIngredient(ingredient, jwtToken){
		return getApi().post(`/ingredients/?tenantId=${ingredient.tenantId}`, ingredient, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	getIngredient(ingredientId, tenantId, jwtToken) {
		return getApi().get(`/ingredients/${ingredientId}?tenantId=${tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	deleteIngredient(ingredient, jwtToken) {
		return getApi().delete(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},
	async deleteIngredientAndProductIngredients(ingredient, jwtToken) {
		const [productsIngredients, deletedIngredient] = await Promise.all([
			ProductsIngredientsProvider.deleteProductsIngredients(ingredient, jwtToken),
			getApi().delete(`/ingredients/${ingredient.id}?tenantId=${ingredient.tenantId}`, {
				headers: {
					Authorization: jwtToken
				}
			})
		]);
		return {
			productsIngredients,
			ingredient: deletedIngredient
		};
	}
});

export default IngredientsProvider;
